export function hitungHargaRental({
    hargaUnit,
    jarakKm,
    durasiJam,
    hargaPerKm,
    hargaPerJam,
    biayaSupir,
    biayaBBM,
    inapDriver,
    transferOut,
    transferIn,
    makanDriver,
    biayaTol,
    biayaParkir,
    biayaLain,
    diskonPersen,
    ppnPersen,
    tambahanPenumpang,
    biayaAsuransi,
    biayaAdmin,
    markupPersen,
    lat,
    lon
}) {
    const biayaJarak = jarakKm * hargaPerKm;
    const biayaDurasi = durasiJam * hargaPerJam;

    let subtotal = hargaUnit + biayaJarak + biayaDurasi + biayaSupir + biayaBBM +
                   inapDriver + transferOut + transferIn + makanDriver + biayaTol +
                   biayaParkir + biayaLain + tambahanPenumpang + biayaAsuransi + biayaAdmin;

    subtotal += subtotal * (markupPersen / 100);
    const diskon = subtotal * (diskonPersen / 100);
    const ppn = (subtotal - diskon) * (ppnPersen / 100);
    const total = subtotal - diskon + ppn;

    return {
        biayaJarak,
        biayaDurasi,
        subtotal: subtotal.toFixed(2),
        diskon: diskon.toFixed(2),
        ppn: ppn.toFixed(2),
        total: total.toFixed(2)
    };
}

export async function fetchRentalAllPrice(params) {
    try {
        const response = await fetch('/pelayanan/get-car-category-radius', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                distance: params.distance,
                order_date: params.orderDate,
                delivery_date: params.deliveryDate,
                kota_asal: params.kotaAsal,
                kota_tujuan: params.kotaTujuan,
                inap: params.inap || 0,
                biaya_makan: params.biayaMakan || 0,
                biaya_buah: params.biayaBuah || 0,
                biaya_bunga: params.biayaBunga || 0,
                biaya_parcel: params.biayaParcel || 0,
                biaya_dekorasi: params.biayaDekorasi || 0,
                category_id: params.categoryId || 0,
                company_id: params.companyId || 0,
                lat: params.lat || 0,
                lon: params.lon || 0
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result?.data || []; // selalu return array mobil
    } catch (err) {
        console.error("Gagal hitung harga rental:", err);
        return [];
    }
}

function renderSkeleton(count = 6) {
    modalDetail.innerHTML = Array.from({ length: count }).map(() => `
        <div class="animate-pulse">
            <div class="bg-white rounded-xl border p-3 flex gap-4">
                <div class="w-16 h-16 bg-gray-200 rounded-lg"></div>
                <div class="flex-1 space-y-2">
                    <div class="h-4 bg-gray-200 rounded w-3/4"></div>
                    <div class="h-3 bg-gray-200 rounded w-1/2"></div>
                    <div class="h-3 bg-gray-200 rounded w-1/3"></div>
                </div>
            </div>
        </div>
    `).join('');
}

export async function fetchRentalAllPriceDetails(params) {
    try {
        renderSkeleton();
        const jumlahHari = hitungJumlahHari();
        const response = await fetch('/pelayanan/get-car-category-radius', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute('content')
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                lat: params.lat,
                lon: params.lon,
                category_id: params.categoryId ?? null,
                city: params.city || null,
                kota_tujuan: params.kotaTujuan || null,
                destinasi: params.destinasi || null,
                jarak: params.jarak || 0,
                name: params.name || null,
                dalam_kota_code: params.dalamKotaCode || 0,
                jumlah_hari: jumlahHari,
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        // backend return { success, data }
        return result.data ?? [];

    } catch (err) {
        console.error('Gagal ambil data rental:', err);
        return [];
    }
}

export async function fetchRentalAllPriceDetailsByVendor(params) {
    try {
        renderSkeleton();
        const jumlahHari = hitungJumlahHari();
        const response = await fetch('/pelayanan/get-car-vendor-category', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute('content')
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                vendorId: params.vendorId ?? null,
                categoryId: params.categoryId ?? null,
                tanggal_jemput: params.tanggalJemput,
                tanggal_selesai: params.tanggalSelesai
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        // backend return { success, data }
        return result.data ?? [];

    } catch (err) {
        console.error('Gagal ambil data rental:', err);
        return [];
    }
}

function hitungJumlahHari() {
    const start = document.getElementById('tanggalJemputPelayanan').value;
    const end   = document.getElementById('tanggalSelesaiPelayanan').value;

    if (!start || !end) return 0;

    const startDate = new Date(start.replace(' ', 'T'));
    const endDate   = new Date(end.replace(' ', 'T'));

    // Selisih ms
    const diffMs = endDate - startDate;

    if (diffMs <= 0) return 0;

    // Konversi ke hari (dibulatkan ke atas)
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    return diffDays;
}

// function hitungJumlahHari() {

//     const tabAktif = Alpine.store('tripTabsPelayanan').activeTab;

//     let start = "";
//     let end = "";

//     if (tabAktif === "tab1") {

//         start = document.getElementById(
//             'tanggalJemputPelayanan'
//         )?.value;

//         end = document.getElementById(
//             'tanggalSelesaiPelayanan'
//         )?.value;

//     } else {

//         const range = document.getElementById(
//             'tanggalRangePelayananMr'
//         )?.value;

//         if (range) {
//             [start, end] = range.split(" to ");
//         }
//     }

//     if (!start || !end) return 0;

//     const startDate = new Date(start.replace(' ', 'T'));
//     const endDate = new Date(end.replace(' ', 'T'));

//     const diffMs = endDate - startDate;

//     if (diffMs <= 0) return 0;

//     return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
// }

export async function fetchRentalPrice(params) {
    try {
        const response = await fetch('/pelayanan/get-total-price', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({
                distance: params.distance,
                car_id: params.carId,
                order_date: params.orderDate,
                delivery_date: params.deliveryDate,
                kota_asal: params.kotaAsal,
                kota_tujuan: params.kotaTujuan,

                costPelayanan: params.costPelayanan || [],

                inap: params.inap || 0,
                biaya_makan: params.biayaMakan || 0,
                biaya_buah: params.biayaBuah || 0,
                biaya_bunga: params.biayaBunga || 0,
                biaya_parcel: params.biayaParcel || 0,
                biaya_dekorasi: params.biayaDekorasi || 0,
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result?.data || null;
    } catch (err) {
        console.error("Gagal hitung harga rental:", err);
        return null;
    }
}

export async function fetchRentalAllPriceByVendor(params) {
    try {
        const response = await fetch('/pelayanan/get-car-vendor-category', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                vendorId: params.vendorId,
                categoryId: params.categoryId,
                tanggal_jemput: params.tanggalJemput,
                tanggal_selesai: params.tanggalSelesai
            })
        });

        const result = await response.json();
        return result?.data || [];
    } catch (err) {
        console.error("Gagal hitung harga rental:", err);
        return [];
    }
}
